//высота элемента выбора
export const SCROLL_SELECT_ITEM_HEIGHT = 150;
export const SCROLL_SELECT_ITEM_HEIGHT_FAVORITE = 64;

// время после нажатия на элемент выбора
export const SCROLL_SELECT_ITEM_DELAY = 400;
//высота элемента выбора
export const SCROLL_SELECT_ITEM_HEIGHT = 150;
export const SCROLL_SELECT_ITEM_HEIGHT_FAVORITE = 64;

// время после нажатия на элемент выбора
export const SCROLL_SELECT_ITEM_DELAY = 400;
